<template>
  <div class="storeListDiv">
    <van-tabs
      v-model="lineListActive"
      v-if="lineList.length > 1"
      sticky
      @change="changeTab"
      class="vanLine"
    >
      <van-tab :title="item.name" v-for="item in lineList" :key="item.id">
      </van-tab>
    </van-tabs>
    <div class="cont1" :style="{ top: lineList.length > 1 ? '45px' : '0' }">
      <div v-if="isWarehouseman" style="flex: 1">
        <div
          :class="isActive === 'queuing' ? 'blk cont1-blk1' : 'blk cont1-blk2'"
          @click="changeBtn('queuing')"
        >
          排队中<br />
          <span style="font-size: 16px">{{ queuingList.length }}</span>
        </div>
      </div>
      <div style="flex: 1">
        <div
          :class="isActive === 'calling' ? 'blk cont1-blk1' : 'blk cont1-blk2'"
          @click="changeBtn('calling')"
        >
          叫号中<br />
          <span style="font-size: 16px">{{ callingList.length }}</span>
        </div>
      </div>
      <div style="flex: 1">
        <div
          :class="isActive === 'loading' ? 'blk cont1-blk1' : 'blk cont1-blk2'"
          @click="changeBtn('loading')"
        >
          <!-- 装货中<br /> -->
          {{ typeTextFormat(type) }}中
          <br />
          <span style="font-size: 16px">{{ loadingList.length }}</span>
        </div>
      </div>
      <div style="flex: 1">
        <div
          :class="
            isActive === 'accomplish' ? 'blk cont1-blk1' : 'blk cont1-blk2'
          "
          @click="changeBtn('accomplish')"
        >
          已完成<br />
          <span style="font-size: 16px">{{ loadingEndList.length }}</span>
        </div>
      </div>
    </div>

    <div :style="{ height: lineList.length > 1 ? '133px' : '88px' }"></div>

    <van-tabs v-model="activeModule" @click="changModule" v-if="isShowModule">
      <div class="moduleBlack">
        <van-tab title="我的"> </van-tab>
        <van-tab title="全部"> </van-tab>
      </div>
    </van-tabs>

    <!-- 排队中 -->
    <div class="cont2" v-if="isActive === 'queuing'">
      <div
        class="cont2-left defaultBg"
        v-for="(item, index) in queuingList"
        :key="index"
      >
        <div class="cont2-left-blk">
          <div class="top">{{ item.code }}</div>
          <div class="image">
            <!-- 不同车的类型不一致 车辆类型（1平板车；2货柜车；3槽罐车；4其他；5高栏车）-->
            <!-- 平板车 -->
            <img
              src="../assets/img/flat.png"
              alt=""
              width="70px"
              v-if="item.report_info.vehicle_type === 1"
            />
            <!-- 货柜车 -->
            <img
              src="../assets/img/truck.png"
              alt=""
              width="70px"
              v-else-if="item.report_info.vehicle_type === 2"
            />
            <!-- 高栏车 -->
            <img
              src="../assets/img/gaolan.png"
              alt=""
              width="70px"
              v-else-if="item.report_info.vehicle_type === 5"
            />
            <img src="../assets/img/else_icon.png" v-else alt="" width="70px" />
          </div>
          <div v-if="item.work_state == 2" class="bottom">正在作业中</div>
        </div>
        <div class="cont2-right">
          <span class="right12">
            <span class="right1">
              <span>
                {{ item.report_info.license_plate }}
              </span>
              <span v-if="item.business_type == 0" class="ylIcon">
                <img src="../assets/img/truck-yl.png" alt="" width="20px" />
              </span>
            </span>
            <span class="right2"
              >车型：{{ vehicleTypeText(item.report_info.vehicle_type) }}</span
            >
          </span>
          单据编号：<span style="color: red;word-break: break-all;">{{ item.order_code || '--' }}</span><br />
          收货单位：<span>{{ item.delivery_unit || '--' }}</span><br />
          单位：{{ item.report_info.unit }}<br />
          进厂时间：<span v-if="item.into_factory_time > 0">{{
            formatTime(item.into_factory_time)
          }}</span>
          <span v-else>--</span><br />
          手机号码：<span class="colorBlue">{{ item.report_info.contact }}</span
          ><br />
          <template v-if="item.booking_note">
            备注：<span style="word-break: break-all;">{{ item.booking_note }}</span><br />
          </template>
          <span v-if="item.into_factory_time == 0">--</span>
          <span v-else-if="item.into_factory_time > 0">
            <span
              v-if="
                formatStatus(item.into_factory_time, item.booking_time) == 0
              "
              class="colorBlueLight"
              >提前到厂</span
            >

            <!-- <span v-else-if="item.loading_time > 0">提前到厂</span> -->
            <span
              v-if="
                formatStatus(item.into_factory_time, item.booking_time) == 1
              "
              class="colorGreenDark"
              >准时到厂</span
            >
            <span
              v-if="
                formatStatus(item.into_factory_time, item.booking_time) == 2
              "
              class="colorPink"
              >迟到到厂</span
            >
          </span>

          <!-- <span class="right5">已等待：{{ timeCacl(item.create_time) }}</span> -->
          <span class="right5"><waitAndReportShow :item="item"></waitAndReportShow></span>
          <br />
          <span v-if="item.car_tag" class="car_tag_class" style="margin-right: 8px;">{{ item.car_tag }}</span>
          <span v-if="item.two_factories == 1" class="car_tag_class">两厂装</span>
        </div>
      </div>
      <Empty v-if="queuingList.length == 0"> </Empty>
    </div>

    <!-- 叫号中 -->
    <div class="cont3" v-if="isActive === 'calling'">
      <div class="cont3-title">正在叫号：</div>
      <template v-for="(item, index) in callingList">
        <div
          class="defaultBg mgBottom10"
          :key="index"
          style="display: flex"
          v-show="activeModule == 0 ? item.is_mine : true"
        >
          <div class="cont3-left">
            <div class="top">{{ item.code }}</div>
            <div style="padding: 0px 10px">
              <span class="left1">{{ item.report_info.license_plate }}</span>
              <span class="left2"
                >车型：{{
                  vehicleTypeText(item.report_info.vehicle_type)
                }}</span
              ><br />
              <span v-if="!type">
                装货位置：
                <span class="colorGreenDark"
                  >{{ item.warehouse.store_name }}
                  {{ item.warehouse.warehouse_name }}</span
                ><br
              /></span>
              单据编号：<span style="color: red;word-break: break-all;">{{ item.order_code || '--' }}</span><br />
              收货单位：<span>{{ item.delivery_unit || '--' }}</span><br />
              单位：{{ item.report_info.unit }}<br />
              手机号码：<span class="colorBlue">{{
                item.report_info.contact
              }}</span
              ><br />
              <template v-if="item.booking_note">
                备注：<span style="word-break: break-all;">{{ item.booking_note }}</span><br />
              </template>
              已叫号：<span class="colorGreenDark">{{
                timeCacl(item.call_number_time)
              }}</span
              ><br />
              监装员：{{ item.warehouseman }}
            </div>
          </div>
          <!-- <div class="cont3-right">
            <div>
              <van-button
                type="primary"
                class="btn"
                v-show="isShowBtn"
                @click="handle('confirmArrival', item)"
                v-if="
                  privilegeConfig.keys &&
                    privilegeConfig.keys.indexOf('c-car-qeue-ww-leave-truck') >=
                      0
                "
                >确认到达</van-button
              >
            </div>
          </div> -->
        </div>
      </template>
      <Empty v-if="callingList.length == 0"></Empty>
    </div>
    <div class="cont3" v-if="isActive === 'calling'">
      <div class="cont3-title">已过号(超过35分钟)：</div>
      <div
        class="defaultBg mgBottom10"
        v-for="(item, index) in callingPassList"
        :key="index"
        style="display: flex"
      >
        <div class="cont3-left">
          <div class="top">{{ item.code }}</div>
          <div style="padding: 0px 10px">
            <span class="left1">{{ item.report_info.license_plate }}</span>
            <span class="left2"
              >车型：{{ vehicleTypeText(item.report_info.vehicle_type) }}</span
            ><br />
            <span v-if="!type"
              >装货位置：
              <span class="colorGreenDark"
                >{{ item.warehouse.store_name }}
                {{ item.warehouse.warehouse_name }}</span
              ><br
            /></span>
            单据编号：<span style="color: red;word-break: break-all;">{{ item.order_code || '--' }}</span><br />
            收货单位：<span>{{ item.delivery_unit || '--' }}</span><br />
            单位：{{ item.report_info.unit }}<br />
            手机号码：<span class="colorBlue">{{
              item.report_info.contact
            }}</span
            ><br />
            <template v-if="item.booking_note">
              备注：<span style="word-break: break-all;">{{ item.booking_note }}</span><br />
            </template>
            已叫号：<span class="colorGreenDark">{{
              timeCacl(item.call_number_time)
            }}</span>
            <br />
            监装员：{{ item.warehouseman }}
          </div>
        </div>
        <div class="cont3-right">
          <div>
            <van-button
              type="primary"
              class="btn"
              v-show="isShowBtn"
              @click="handle('requeue', item)"
              v-if="
                privilegeConfig.keys &&
                  privilegeConfig.keys.indexOf('c-car-qeue-ww-leave-truck') >= 0
              "
              >重新排队</van-button
            >
          </div>
          <!-- <div>
            <van-button
              type="primary"
              class="btn btnGrey"
              @click="handle('confirmArrival', item)"
              >确认到达</van-button
            >
          </div> -->
        </div>
      </div>
      <Empty v-if="callingPassList.length == 0"></Empty>
    </div>

    <!-- 装货中 -->
    <div class="cont3" v-if="isActive === 'loading'">
      <template v-for="(item, index) in loadingList">
        <div
          class="defaultBg mgBottom10"
          v-show="activeModule == 0 ? item.is_mine : true"
          :key="index"
          style="display: flex"
        >
          <div class="cont3-left">
            <div class="top">{{ item.code }}</div>
            <div style="padding: 0px 10px">
              <span class="left1">{{ item.report_info.license_plate }}</span>
              <span class="left2"
                >车型：{{
                  vehicleTypeText(item.report_info.vehicle_type)
                }}</span
              ><br />
              状态：
              <span class="colorGreenDark">{{
                loadingStateText(item.loading_state, type)
              }}</span
              ><br />
              单据编号：<span style="color: red;word-break: break-all;">{{ item.order_code || '--' }}</span><br />
              收货单位：<span>{{ item.delivery_unit || '--' }}</span><br />
              单位：{{ item.report_info.unit }}<br />
              手机号码：<span class="colorBlue">{{
                item.report_info.contact
              }}</span
              ><br />
              <template v-if="item.booking_note">
                备注：<span style="word-break: break-all;">{{ item.booking_note }}</span><br />
              </template>
              {{ typeTextFormat(type) }}计时：{{
                item.loading_time > 0 ? timeCacl(item.loading_time) : "--"
              }}<br />
              <!-- 成品入厂类型不需要显示位置 -->
              <span v-if="!type"
                >装货位置:
                <span class="colorGreenDark"
                  >{{ item.warehouse.store_name }}
                  {{ item.warehouse.warehouse_name }}</span
                ><br
              /></span>
              监装员：{{ item.warehouseman }}
            </div>
          </div>
          <div class="cont3-right">
            <div
              v-if="
                item.loading_state == 1 &&
                  privilegeConfig.keys &&
                  privilegeConfig.keys.indexOf('c-car-qeue-ww-leave-truck') >= 0
              "
            >
              <van-button
                type="primary"
                class="btn"
                v-show="isShowBtn"
                @click="handle('startLoading', item)"
                >开始{{ typeTextFormat(type) }}</van-button
              >
            </div>
            <div
              v-if="
                item.loading_state == 1 &&
                  privilegeConfig.keys &&
                  privilegeConfig.keys.indexOf('c-car-qeue-ww-leave-truck') >=
                    0 &&
                  !type
              "
            >
              <van-button
                type="primary"
                class="btn btnPink"
                v-show="isShowBtn"
                @click="handle('rejectLoading', item)"
                >拒绝装车</van-button
              >
            </div>
            <!-- 已开单按钮，先注释隐藏 -->
            <!-- <div
              v-if="
                item.loading_state == 4 &&
                  privilegeConfig.keys &&
                  privilegeConfig.keys.indexOf('c-car-qeue-ww-leave-truck') >= 0
              "
            >
              <van-button
                type="primary"
                class="btn btnBlue"
                v-show="isShowBtn && !type"
                @click="handle('billed', item)"
                >已开单</van-button
              >
            </div> -->
            <div
              v-if="
                item.loading_state == 3 &&
                  privilegeConfig.keys &&
                  privilegeConfig.keys.indexOf('c-car-qeue-ww-leave-truck') >= 0
              "
            >
              <van-button
                type="primary"
                class="btn btnOrange"
                v-show="isShowBtn"
                @click="handle('completeLoading', item)"
                >{{ typeTextFormat(type) }}完成</van-button
              >
            </div>
            <div
              v-if="
                item.loading_state == 3 &&
                  privilegeConfig.keys &&
                  privilegeConfig.keys.indexOf('c-car-qeue-ww-leave-truck') >=
                    0 &&
                  !type
              "
            >
              <van-button
                type="primary"
                class="btn btnPink"
                v-show="isShowBtn"
                @click="handle('completeEnding', item)"
                >终止装车</van-button
              >
            </div>
          </div>
        </div>
      </template>

      <Empty v-if="loadingList.length == 0"></Empty>
    </div>
    <!-- 已完成 -->
    <div class="cont3" v-if="isActive === 'accomplish'">
      <!-- <div class="cont3-title">已结束：</div> -->
      <template v-for="(item, index) in loadingEndList">
        <div
          class="defaultBg mgBottom10"
          v-show="activeModule == 0 ? item.is_mine : true"
          :key="index"
          style="display: flex"
        >
          <div class="cont3-left">
            <div class="top greyBg">{{ item.code }}</div>
            <div style="padding: 0px 10px">
              <span class="left1">{{ item.report_info.license_plate }}</span>
              <span class="left2"
                >车型：{{
                  vehicleTypeText(item.report_info.vehicle_type)
                }}</span
              ><br />

              状态：{{ loadingStateText(item.loading_state, type) }}<br />
              单据编号：<span style="color: red;word-break: break-all;">{{ item.order_code || '--' }}</span><br />
              收货单位：<span>{{ item.delivery_unit || '--' }}</span><br />
              单位：{{ item.report_info.unit }}<br />
              手机号码：{{ item.report_info.contact }}<br />
              <template v-if="item.booking_note">
                备注：<span style="word-break: break-all;">{{ item.booking_note }}</span><br />
              </template>
              {{ typeTextFormat(type) }}计时：{{
                Number(item.total_loading_time) > 0
                  ? minNumTotext(Number(item.total_loading_time))
                  : "--"
              }}<br />
              监装员：{{ item.warehouseman }}<br />
              操作时间：{{ formatTime(item.update_time) }}
            </div>
          </div>
          <div class="cont3-right"></div>
        </div>
      </template>

      <Empty v-if="loadingEndList.length == 0"></Empty>
    </div>
    <div
      class="cont3"
      v-if="isActive === 'loading' && loadingRejectList.length > 0"
    >
      <div class="cont3-title">已拒绝（不符合装车要求）：</div>
      <!--  v-show="activeModule == 0 ? item.is_mine : true" -->
      <template v-for="(item, index) in loadingRejectList">
        <div class="defaultBg mgBottom10" :key="index" style="display: flex">
          <div class="cont3-left">
            <div class="top greyBg">{{ item.code }}</div>
            <div style="padding: 0px 10px">
              <span class="left1">{{ item.report_info.license_plate }}</span>
              <span class="left2"
                >车型：{{
                  vehicleTypeText(item.report_info.vehicle_type)
                }}</span
              ><br />
              状态：{{ loadingStateText(item.loading_state, type) }}<br />
              单据编号：<span style="color: red;word-break: break-all;">{{ item.order_code || '--' }}</span><br />
              收货单位：<span>{{ item.delivery_unit || '--' }}</span><br />
              单位：{{ item.report_info.unit }}<br />
              装货计时：{{
                item.loading_time > 0 ? timeCacl(item.loading_time) : "--"
              }}<br />
              <!-- <span class="left5"> -->
              监装员：{{ item.warehouseman }}
              <!-- </span> -->
              <br />
              拒绝理由：{{ item.refused_loading_reason }}
            </div>
          </div>
          <div class="cont3-right">
            <div
              v-if="
                item.loading_state == 2 &&
                  privilegeConfig.keys &&
                  privilegeConfig.keys.indexOf('c-car-qeue-ww-leave-truck') >= 0
              "
            >
              <van-button
                type="primary"
                class="btn"
                v-show="isShowBtn"
                @click="handle('confirmArrival', item)"
                >重新装车</van-button
              >
            </div>
          </div>
        </div>
      </template>
      <Empty v-if="loadingRejectList.length == 0"></Empty>
    </div>
    <!-- <div class="cont3" v-if="isActive === 'loading'">
      <div class="cont3-title">已结束：</div>
      <div
        class="defaultBg mgBottom10"
        v-for="(item, index) in loadingEndList"
        :key="index"
        style="display: flex"
      >
        <div class="cont3-left">
          <div class="top greyBg">{{ item.code }}</div>
          <div style="padding: 0px 10px">
            <span class="left1">{{ item.report_info.license_plate }}</span>
            <span class="left2"
              >车型：{{ vehicleTypeText(item.report_info.vehicle_type) }}</span
            ><br />
            状态：{{ loadingStateText(item.loading_state) }}<br />
            单位：{{ item.report_info.unit }}<br />
            手机号码：{{ item.report_info.contact }}<br />
            装货计时：{{
              Number(item.total_loading_time) > 0
                ? minNumTotext(Number(item.total_loading_time))
                : "--"
            }}<br />
            监装员：{{ item.warehouseman }}<br />
            操作时间：{{ formatTime(item.update_time) }}
          </div>
        </div>
        <div class="cont3-right"></div>
      </div>
      <Empty v-if="loadingEndList.length == 0"></Empty>
    </div> -->

    <div
      style="height: 86px; background-color: #f4f5f6"
      v-if="isActive === 'queuing'"
    ></div>
    <div
      class="footer-cont"
      v-if="
        isActive === 'queuing' &&
          privilegeConfig.keys &&
          privilegeConfig.keys.indexOf('c-car-qeue-ww-leave-call') >= 0
      "
    >
      <van-button
        type="primary"
        block
        class="btnStyle1"
        @click="intoCallingPage"
        >叫号</van-button
      >
    </div>

    <!-- 弹窗 -->
    <van-dialog
      v-model="dialogShow"
      class="vanDialog"
      show-cancel-button
      :showConfirmButton="false"
      :showCancelButton="false"
    >
      <template #default>
        <div class="dialog-blk">
          <div v-if="dialogType === 'confirmArrival'">
            是否确认“<span class="colorPink">{{
              actionQueueObj.report_info.license_plate
            }}</span
            >”已到达{{ typeTextFormat(type) }}位置？
            <!-- 超时 -->
            <template v-if="actionQueueOutTime">
              <p class="actionQueueReasonTitle">
                已超出{{ actionQueueOverTime }}分钟，请选择超时原因：
              </p>
              <el-select
                v-model="actionQueueReason"
                popper-class="elSelectpopper"
                placeholder="请选择超时原因"
              >
                <el-option
                  v-for="(item, index) in actionQueueOutTimeResoinList"
                  :key="index"
                  :label="item.name"
                  :value="item.key"
                >
                </el-option>
              </el-select>
              <van-field
                v-model="actionQueueReasonInput"
                rows="3"
                :border="true"
                autosize
                label=""
                type="textarea"
                maxlength="50"
                placeholder="请输入超时原因"
                show-word-limit
              />
            </template>
          </div>
          <div v-if="dialogType === 'requeue'">
            是否确认“<span class="colorPink">{{
              actionQueueObj.report_info.license_plate
            }}</span
            >”重新开始排队？
          </div>
          <div v-if="dialogType === 'startLoading'">
            {{ typeTextFormat(type) }}前请检查车辆<span class="colorPink"
              >是否符合{{ typeTextFormat(type) }}要求</span
            >， 确认“<span class="colorPink">{{
              actionQueueObj.report_info.license_plate
            }}</span>
            ”已准备就绪，可开始{{ typeTextFormat(type) }}？
            <!-- 超时 -->
            <template v-if="actionQueueOutTime">
              <p class="actionQueueReasonTitle">
                已超出{{ actionQueueOverTime }}分钟，请选择超时原因：
              </p>
              <el-select
                v-model="actionQueueReason"
                popper-class="elSelectpopper"
                placeholder="请选择超时原因"
              >
                <el-option
                  v-for="(item, index) in actionQueueOutTimeResoinList"
                  :key="index"
                  :label="item.name"
                  :value="item.key"
                >
                </el-option>
              </el-select>
              <van-field
                v-model="actionQueueReasonInput"
                rows="3"
                :border="true"
                autosize
                label=""
                type="textarea"
                maxlength="50"
                placeholder="请输入超时原因"
                show-word-limit
              />
            </template>
          </div>
          <div v-if="dialogType === 'completeLoading'">
            是否确认“<span class="colorPink">{{
              actionQueueObj.report_info.license_plate
            }}</span
            >”已{{ typeTextFormat(type) }}完成？
            <!-- 超时 -->
            <template v-if="actionQueueOutTime">
              <p class="actionQueueReasonTitle">
                已超出{{ actionQueueOverTime }}分钟，请选择超时原因：
              </p>
              <el-select
                v-model="actionQueueReason"
                popper-class="elSelectpopper"
                placeholder="请选择超时原因"
              >
                <el-option
                  v-for="(item, index) in actionQueueOutTimeResoinList"
                  :key="index"
                  :label="item.name"
                  :value="item.key"
                >
                </el-option>
              </el-select>
              <van-field
                v-model="actionQueueReasonInput"
                rows="3"
                :border="true"
                autosize
                label=""
                type="textarea"
                maxlength="50"
                placeholder="请输入超时原因"
                show-word-limit
              />
            </template>
          </div>
          <div v-if="dialogType === 'completeEnding'">
            正在对“<span class="colorPink">{{
              actionQueueObj.report_info.license_plate
            }}</span
            >”执行<span class="colorPink">终止装车</span>操作
            <!-- 超时 -->
            <template v-if="actionQueueOutTime">
              <p class="actionQueueReasonTitle">请选择终止装车理由：</p>
              <el-select
                v-model="actionQueueReason"
                popper-class="elSelectpopper"
                placeholder="请选择终止装车理由："
              >
                <el-option
                  v-for="(item, index) in actionQueueOutTimeResoinList"
                  :key="index"
                  :label="item.name"
                  :value="item.key"
                >
                </el-option>
              </el-select>
              <van-field
                v-model="actionQueueReasonInput"
                rows="3"
                :border="true"
                autosize
                label=""
                type="textarea"
                maxlength="50"
                placeholder="请输入理由"
                show-word-limit
              />
            </template>
          </div>
          <div v-if="dialogType === 'billed'">
            是否确认“<span class="colorPink">{{
              actionQueueObj.report_info.license_plate
            }}</span
            >”单据已交接？
            <!-- 超时 -->
            <template v-if="actionQueueOutTime">
              <p class="actionQueueReasonTitle">
                已超出{{ actionQueueOverTime }}分钟，请选择超时原因：
              </p>
              <el-select
                v-model="actionQueueReason"
                popper-class="elSelectpopper"
                placeholder="请选择超时原因"
              >
                <el-option
                  v-for="(item, index) in actionQueueOutTimeResoinList"
                  :key="index"
                  :label="item.name"
                  :value="item.key"
                >
                </el-option>
              </el-select>
              <van-field
                v-model="actionQueueReasonInput"
                rows="3"
                :border="true"
                autosize
                label=""
                type="textarea"
                maxlength="50"
                placeholder="请输入超时原因"
                show-word-limit
              />
            </template>
          </div>
          <div v-if="dialogType === 'rejectLoading'">
            正在对“<span class="colorPink">{{
              actionQueueObj.report_info.license_plate
            }}</span>
            ” 执行<span class="colorPink">拒绝装车</span>操作
            <!-- 拒绝理由 -->
            <template v-if="actionQueueOutTime">
              <p class="actionQueueReasonTitle">请选择拒绝理由：</p>
              <el-select
                v-model="actionQueueReason"
                popper-class="elSelectpopper"
                placeholder="请选择拒绝理由"
              >
                <el-option
                  v-for="(item, index) in actionQueueOutTimeResoinList"
                  :key="index"
                  :label="item.name"
                  :value="item.key"
                >
                </el-option>
              </el-select>
              <van-field
                v-model="actionQueueReasonInput"
                rows="3"
                :border="true"
                autosize
                label=""
                type="textarea"
                maxlength="50"
                placeholder="请输入拒绝理由"
                show-word-limit
              />
            </template>

            <!-- 
              请输入拒绝理由：
            <van-field
              v-model="rejectReason"
              rows="3"
              :autosize="{ maxHeight: 100, minHeight: 50 }"
              type="textarea"
              placeholder="请输入拒绝理由"
              style="border: 1px solid #eee; margin-top: 8px"
            /> -->
          </div>
        </div>
        <div style="display: flex">
          <div style="flex: 1" @click="dialogShow = false">
            <van-button block class="dialogBtnCancel">取消</van-button>
          </div>
          <div style="flex: 1" @click="onConfirm">
            <van-button block class="dialogBtnConfirm">确认无误</van-button>
          </div>
        </div>
      </template>
      <template #title>
        <div style="font-size: 15px">确认提示</div>
      </template>
    </van-dialog>
    <mbComSelect></mbComSelect>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import { Toast } from "vant";
import moment from "moment";
import socketListStoreMixin from "@/mixins/rh/socketListStoreMixin.js";
import socketListComputedMixin from "@/mixins/rh/socketListComputedMixin.js";
import socketConnetMixin from "@/mixins/rh/socketConnetMixin.js";
import mbComSelect from "@/components/mbComSelect/index.vue";
import Empty from "@/components/tips/Empty.vue";
import privilegeMixin from "@/mixins/rh/privilegeMixin.js";
import waitAndReportShow from "@/views/rhwx/commonComponent/waitAndReportShow.vue";

export default {
  props: {},
  data() {
    return {
      socketConnetMixinRoom: "ROOM_QUEUE_WAREHOUSEMAN",
      isActive: "",
      dialogShow: false,
      dialogType: "",
      rejectReason: "", // 拒绝理由
      actionQueueId: "",
      actionQueueObj: "",
      actionQueueReason: "",
      actionQueueOutTime: false,
      actionQueueReasonInput: "",
      actionQueueOutTimeResoin: { list: [], other: false },
      actionQueueOverTime: "",
      isWarehouseman: false, // 是否班长
      queuingList: [], // 排队中
      callingList: [], // 叫号中
      callingPassList: [], // 叫号中-过号
      loadingList: [], // 装货中
      loadingRejectList: [], // 装货中-拒绝装货
      loadingEndList: [], // 装货中-结束
      lineList: [], // 产品线
      lineListActive: 0, // 当前选中的产品线
      calculationTime: null,
      calculationTimeInterval: null,
      isShowModule: false, //我的 全部 tabs显示隐藏  11111
      activeModule: 0, //1显示全部
      is_mine: false, //false为全部, true为我的
      isShowBtn: true
    };
  },
  beforeRouteLeave(_to, _form, next) {
    try {
      window.clearInterval(this.calculationTimeInterval);
    } catch (error) {
      console.error(error);
    }
    next();
  },
  mixins: [
    socketConnetMixin,
    socketListStoreMixin,
    socketListComputedMixin,
    privilegeMixin
  ],
  watch: {
    async isJoinRoomAndMonitorEven(val) {
      if (val) {
        console.log("清空数据");
        this.queuingList = []; // 排队中
        this.callingList = []; // 叫号中
        this.callingPassList = []; // 叫号中-过号
        this.loadingList = []; // 装货中
        this.loadingRejectList = []; // 装货中-拒绝装货 1
        this.loadingEndList = []; // 装货中-结束
        console.log("获取业务数据");
        let proLines = await this.getProLines();
        this.lineList = proLines.data.data;
        let permission = await this.getPermission();
        permission = permission.data.data;
        // console.log(permission);
        // 班长显示排队中的业务线
        if (permission.keys.indexOf("c-car-qeue-ww-leave-call") >= 0) {
          this.isWarehouseman = true;
          this.isActive = "queuing";
        } else {
          this.isWarehouseman = false;
          this.isActive = "calling";
        }
        this.getListData();
      } else {
        console.log("socket断开");
      }
    },
    evenQueueList(val) {
      console.warn("socket数据来", evenQueue);
      const evenQueue = JSON.parse(val);
      this.changeAllList(evenQueue);
    }
  },
  components: {
    mbComSelect,
    Empty,
    waitAndReportShow
  },
  computed: {
    actionQueueOutTimeResoinList() {
      let list = JSON.parse(JSON.stringify(this.actionQueueOutTimeResoin.list));
      if (this.actionQueueOutTimeResoin.other) {
        list.push({ key: "other", name: "其他" });
      }
      return list;
    },
    type() {
      console.log(this.lineList);
      if ( this.lineList[this.lineListActive] && (this.lineList[this.lineListActive].type == 2 || this.lineList[this.lineListActive].type == 3) ) {
        return true;
      } else {
        return false;
      }
    }
  },
  async mounted() {
    this.fetchPrivilege();
  },
  methods: {
    ...mapActions(["fetchPrivilege"]),
    // 切换按钮
    changeBtn(tag) {
      console.log(tag, "tag的值");
      this.isActive = tag;
      this.activeModule = 0; //切换我的 全部 的时候 1 默认为全部
      this.getWcommonList(1);
      this.getWcommonList(2);
      if (this.activeModule == 1) {
        this.isShowBtn = !this.isShowBtn;
      } else if (this.activeModule == 0) {
        this.isShowBtn = true;
      }
      if (this.isActive === "queuing") {
        this.isShowModule = false;
      } else {
        // this.isShowBtn = true;
        this.isShowModule = true;
      }
    },

    // 操作dialog
    async handle(tag, item) {
      console.log(tag, item, "-------------tag, item是什么");

      // 统一点击超时判断
      let outTimeState = false;
      let reason = {
        list: [],
        other: false
      };
      let overtime = "";

      // 超时判断-确认到达tag == "confirmArrival"
      if (
        tag == "confirmArrival" ||
        tag == "startLoading" ||
        tag == "rejectLoading" ||
        tag == "completeEnding" ||
        tag == "completeLoading" ||
        tag == "billed"
      ) {
        let confirmArrivalRes = await this.$common.http({
          url: "/api/queue/warehouseman/check_operation",
          data: {
            id: item.id
          }
        });
        let res = confirmArrivalRes.data.data;
        outTimeState = !res.state;
        overtime = res.overtime;

        // test 强制生效
        // outTimeState = true;

        // 超时原因:确认到达；
        if (
          tag == "confirmArrival" ||
          tag == "startLoading" ||
          tag == "completeLoading" ||
          tag == "billed"
        ) {
          try {
            reason = JSON.parse(res.reason);
          } catch (error) {
            reason = {
              list: [],
              other: false
            };
          }
        }

        // 拒绝原因:
        if (tag == "rejectLoading") {
          //强制显示，填写原因
          outTimeState = true;
          try {
            reason = JSON.parse(res.refuse_reason);
          } catch (error) {
            reason = {
              list: [],
              other: false
            };
          }
        }

        // 终止原因:
        if (tag == "completeEnding") {
          //强制显示，填写原因
          outTimeState = true;
          try {
            reason = JSON.parse(res.stop_reason);
          } catch (error) {
            reason = {
              list: [],
              other: false
            };
          }
        }
      }

      // test 强制生效
      // reason.list = ["123123", "123123213111"];
      // reason.other = true;

      let nList = [];
      reason.list.forEach((item, index) => {
        nList.push({ key: index, name: item });
      });
      reason.list = nList;

      this.dialogShow = true;
      this.dialogType = tag;
      this.actionQueueId = item.id;
      this.actionQueueObj = item;
      // 是否超时
      this.actionQueueOutTime = outTimeState;
      // 超时原因
      this.actionQueueOutTimeResoin = reason;
      // 清空超时的选项
      this.actionQueueReasonInput = "";
      // 清空超时的输入
      this.actionQueueReason = "";
      // 超出时间
      this.actionQueueOverTime =
        parseInt(overtime / 60) == 0 ? 1 : parseInt(overtime / 60);
    },

    // 确认
    async onConfirm() {
      console.log(this.dialogType);
      // confirmArrival 确认到达
      let selctItem =
        this.actionQueueOutTimeResoinList.find(item => {
          return item.key == this.actionQueueReason;
        }) || {};
      let overtime_reason = selctItem.name;
      let note = this.actionQueueReasonInput;
      if (this.actionQueueReason == "other" && note.trim().length == 0) {
        this.$common.mbToastFail("请输入原因");
        return false;
      }

      if (this.dialogType == "confirmArrival") {
        if (
          this.actionQueueOutTime &&
          this.actionQueueReason.toString() == ""
        ) {
          this.$common.mbToastFail("请选择原因");
          return false;
        }
        await this.$common.http({
          url: "/api/queue/warehouseman/reach_queue",
          data: {
            queue_id: this.actionQueueId,
            overtime_reason,
            note
          }
        });
      }
      // requeue 重新排队
      if (this.dialogType == "requeue") {
        await this.$common.http({
          url: "/api/queue/warehouseman/again_queue",
          data: {
            queue_id: this.actionQueueId
          }
        });
      }
      // startLoading 开始装车
      if (this.dialogType == "startLoading") {
        if (
          this.actionQueueOutTime &&
          this.actionQueueReason.toString() == ""
        ) {
          this.$common.mbToastFail("请选择原因");
          return false;
        }
        let data = {
          queue_id: this.actionQueueId,
          state: 3,
          overtime_reason,
          note
        };
        await this.$common.http({
          url: "/api/queue/warehouseman/loading_queue",
          data
        });
      }
      // rejectLoading 拒绝装车
      if (this.dialogType == "rejectLoading") {
        if (
          this.actionQueueOutTime &&
          this.actionQueueReason.toString() == ""
        ) {
          this.$common.mbToastFail("请选择原因");
          return false;
        }

        // 同步赋值原有的拒绝装车原有
        this.rejectReason = overtime_reason;
        if (this.actionQueueReason == "other") {
          this.rejectReason = note;
        }

        if (this.rejectReason.trim() === "") {
          this.$common.mbToastFail("拒绝理由不能为空");
          return false;
        }
        await this.$common.http({
          url: "/api/queue/warehouseman/loading_queue",
          data: {
            queue_id: this.actionQueueId,
            state: 2,
            refused_loading_reason: this.rejectReason,
            overtime_reason,
            note
          }
        });
      }
      // completeLoading 装车完成
      if (this.dialogType == "completeLoading") {
        if (
          this.actionQueueOutTime &&
          this.actionQueueReason.toString() == ""
        ) {
          this.$common.mbToastFail("请选择原因");
          return false;
        }
        let data = {
          queue_id: this.actionQueueId,
          state: 4,
          overtime_reason,
          note
        };
        await this.$common.http({
          url: "/api/queue/warehouseman/loading_queue",
          data
        });
      }
      // billed 已开单
      if (this.dialogType == "billed") {
        if (
          this.actionQueueOutTime &&
          this.actionQueueReason.toString() == ""
        ) {
          this.$common.mbToastFail("请选择原因");
          return false;
        }
        await this.$common.http({
          url: "/api/queue/warehouseman/complete_queue",
          data: {
            queue_id: this.actionQueueId,
            overtime_reason,
            note
          }
        });
      }

      // completeEnding 终止装车
      if (this.dialogType == "completeEnding") {
        if (
          this.actionQueueOutTime &&
          this.actionQueueReason.toString() == ""
        ) {
          this.$common.mbToastFail("请选择原因");
          return false;
        }
        await this.$common.http({
          url: "/api/queue/warehouseman/loading_queue",
          data: {
            queue_id: this.actionQueueId,
            state: 6,
            overtime_reason,
            note
          }
        });
      }

      this.dialogShow = false;
      Toast.success("操作成功");
      this.getWcommonList(2); //确认后再次获取数据
    },

    // 取消
    onCancel() {
      this.dialogShow = false;
    },
    // 获取权限
    getPermission() {
      return this.$common.http({
        method: "get",
        url: "/api/permission/list_mine",
        noLoading: true
      });
    },
    // 获取产品线
    getProLines() {
      return this.$common.http({
        method: "get",
        url: "/api/queue/warehouseman/query_business",
        noLoading: true
      });
    },
    // h获取排队中的数据
    getWarehousemanList() {
      if (!this.isWarehouseman) {
        return;
      }
      this.$common
        .http({
          url: "/api/queue/warehouseman/query_loading_queue",
          data: {
            business_id:
              this.lineList.length > 0
                ? this.lineList[this.lineListActive].id
                : ""
          }
        })
        .then(res => {
          this.queuingList = [];
          this.queuingList = res.data.data;
          // this.queuingList = [{}, {}, {}, {}, {}, {}, {}, {}];
        });
    },
    // h获取查看叫号中，装货中队列
    getWcommonList(state) {
      this.$common
        .http({
          url: "/api/queue/warehouseman/query_queue",
          data: {
            state,
            business_id:
              this.lineList.length > 0
                ? this.lineList[this.lineListActive].id
                : "",
            is_all: this.activeModule,
            is_mine: this.is_mine
          }
        })
        .then(res => {
          console.log(
            res,
            `state ::::${state}：：：：`,
            "res的值2222222222222222"
          );
          const list = res.data.data;
          if (state == 1) {
            // state = 1 是叫号中
            this.callingList = [];
            this.callingPassList = [];
            // this.loadingRejectList = []; //11111111111111111111111111111111111111111111111111111111111111111111111111111
            list.forEach(element => {
              if (element.queue_state == 2) {
                this.callingList.push(element);
              }
              if (element.queue_state == 3) {
                this.callingPassList.push(element);
              }
            });
            // this.callingList = [{}, {}, {}, {}, {}, {}, {}, {}];
            // this.callingPassList = [{}, {}, {}, {}, {}, {}, {}, {}];
          }
          if (state == 2) {
            // state = 2 的时候是装货中
            this.loadingList = [];
            this.loadingEndList = [];
            this.loadingRejectList = []; //111111111111111111111111111111111111111111111111111111111111111111111111111
            list.forEach(element => {
              if (
                element.loading_state == 1 ||
                element.loading_state == 3 ||
                element.loading_state == 4
              ) {
                this.loadingList.push(element);
              }
              if (element.loading_state == 2) {
                console.log(this.loadingRejectList, "858");
                this.loadingRejectList.push(element);
              }
              if (element.loading_state == 5 || element.loading_state == 6) {
                this.loadingEndList.push(element);
              }
            });
            // this.loadingList = [{}, {}, {}, {}, {}, {}, {}, {}];
            // this.loadingEndList = [{}, {}, {}, {}, {}, {}, {}, {}];
          }
        });
    },
    // 切换产品线
    changeTab(index) {
      console.log(index);
      this.getListData();
    },
    // 获取列表数据
    getListData() {
      // this.queuingList = [];
      // this.callingList = [];
      // this.callingPassList = [];
      // this.loadingList = [];
      // this.loadingEndList = [];
      this.getWarehousemanList();
      this.getWcommonList(1);
      this.getWcommonList(2);
    },
    changeAllList({ actions, data }) {
      actions.forEach(element => {
        console.log(element, data);
        // 产品线过滤
        console.log(
          "激活产品线id:" + this.lineList[this.lineListActive].id,
          "变更数据id：" + data.business_id
        );
        if (data.business_id != this.lineList[this.lineListActive].id) {
          return;
        }
        // 排队中
        if (element.queue == "QUEUE_QUEUE") {
          // console.log(
          //   this.queuingList[0].report_info.license_plate,
          //   this.queuingList
          // );
          let tmpQueuingList = JSON.parse(JSON.stringify(this.queuingList));
          this.queuingList = this.reSetListBySocket(
            element.action,
            data,
            tmpQueuingList
          );
          // console.log(
          //   this.queuingList[0].report_info.license_plate,
          //   this.queuingList
          // );
        }
        // 叫号中-正在叫号
        if (element.queue == "QUEUE_CALLING") {
          let tmpCallingList = JSON.parse(JSON.stringify(this.callingList));
          this.callingList = this.reSetListBySocket(
            element.action,
            data,
            tmpCallingList
          );
        }
        // 叫号中-已过号
        if (element.queue == "QUEUE_PASS_CALL") {
          let tmpCallingPassList = JSON.parse(
            JSON.stringify(this.callingPassList)
          );
          this.callingPassList = this.reSetListBySocket(
            element.action,
            data,
            tmpCallingPassList
          );
        }
        // 队列-装车中
        if (element.queue == "QUEUE_LOADING") {
          let tmpLoadingList = JSON.parse(JSON.stringify(this.loadingList));
          this.loadingList = this.reSetListBySocket(
            element.action,
            data,
            tmpLoadingList
          );
        }
        // 队列-完成
        if (element.queue == "QUEUE_FINISH") {
          let tmpLoadingEndList = JSON.parse(
            JSON.stringify(this.loadingEndList)
          );
          this.loadingEndList = this.reSetListBySocket(
            element.action,
            data,
            tmpLoadingEndList
          );
        }
        // 队列-拒绝
        if (element.queue == "QUEUE_REFUSED_LOADING") {
          let tmploadingRejectList = JSON.parse(
            JSON.stringify(this.loadingRejectList)
          );
          this.loadingRejectList = this.reSetListBySocket(
            element.action,
            data,
            tmploadingRejectList
          );
        }
      });
    },
    // 叫号
    intoCallingPage() {
      this.$router.push({
        path: "/rhwxStoreCalling",
        query: {
          business_id: this.lineList[this.lineListActive].id,
          type: this.lineList[this.lineListActive].type
        }
      });
    },
    // 切换 我的 全部
    // 0我的    1全部
    changModule(name) {
      this.activeModule = name;
      // calling 叫号中
      // loading 装车中
      // accomplish 已完成
      if (this.isActive === "calling") {
        this.getWcommonList(1);
      } else if (this.isActive === "loading") {
        this.getWcommonList(2);
      } else if (this.isActive === "accomplish") {
        this.getWcommonList(2);
        console.log(this.isActive);
      }
      // 调用 控制按钮显示隐藏
      this.showBtnFn(name);
      // 控制按钮在我的和全部的显示和隐藏 0代表我的  1代表全部
      // if (name === 1) {
      //   this.isShowBtn = false;
      // } else {
      //   this.isShowBtn = !this.isShowBtn;
      // }
      console.log(name, "我的 0  和 全部 1");
    },
    // 控制按钮显示隐藏
    showBtnFn(name) {
      if (name === 0) {
        this.isShowBtn = true;
      } else {
        this.isShowBtn = false;
      }
    }
  },
  created() {
    // window.setInterval(() => {
    //   this.$common.http({
    //     url: "/api/login_test/ws_test",
    //     data: {
    //       even: "EVENT_QUEUE_REGAIN_RANK",
    //       queue_id: "73c773b78f6a4f17bdd73ffb766df671"
    //     },
    //     noLoading: true
    //   });
    // }, 10000);
    this.calculationTime = moment();
    this.calculationTimeInterval = window.setInterval(() => {
      this.calculationTime = moment();
    }, 60000);
  }
};
</script>
<style lang="less" scoped>
@import "../assets/css/common";
.car_tag_class {
  margin-top: 4px;
  background-color: #f56c6c;
  border-radius: 6px;
  padding: 2px 12px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  color: #FFFFFF;
}
.storeListDiv {
  min-height: 100vh;
  box-sizing: border-box;
  border-top: 1px solid #fff;
  background: #f4f5f6;
  .vanLine {
    position: fixed;
    width: 100%;
    border-bottom: 1px solid #333;
    background: #fff;
    z-index: 999;
    top: 0;
  }
  .cont1 {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    padding: 16px;
    background: #fff;
    position: fixed;
    width: calc(100vw - 32px);
    z-index: 999;
    .blk {
      border: 1px solid #008b5e;
      display: inline-block;
      font-size: 16px;
      padding: 8px 12px;
      border-radius: 3px;
    }
    &-blk1 {
      background: #008b5e;
      color: #fff;
    }
    &-blk2 {
      color: #008b5e;
    }
  }
  // 排队中
  .cont2 {
    background: #fff;
    padding: 16px;
    margin: 10px 0px 10px;
    &-left {
      background: #f9f9fa;
      margin-bottom: 10px;
      display: flex;
      &-blk {
        display: inline-block;
        margin-right: 10px;
        width: 108px;
        // text-align: center;
        vertical-align: top;
        position: relative;
        .top {
          background: #00c8d2;
          box-shadow: 0 2px 4px 0 rgba(0, 200, 210, 0.1);
          border-radius: 4px 0 13px 0;
          // width: 55px;
          text-align: center;
          color: white;
          line-height: 23px;
          margin-bottom: 10px;
          font-size: 18px;
          min-width: 35px;
          display: inline-block;
          padding: 2px 11px;
        }
        .image {
          top: 54%;
          left: 50%;
          position: absolute;
          transform: translate(-50%, -50%);
        }
        .bottom {
          font-size: 14px;
          box-shadow: 0 2px 4px 0 rgba(0, 200, 210, 0.1);
          width: 81px;
          color: white;
          line-height: 23px;
          background: #ec3f67;
          border-radius: 0 11px 0 4px;
          position: absolute;
          text-align: center;
          bottom: 0px;
        }
      }
    }
    &-right {
      display: inline-block;
      font-size: 14px;
      line-height: 22px;
      padding: 12px 0px;
      width: calc(88vw - 120px);
      color: #4f4a4c;
      .right12 {
        display: flex;
        justify-content: space-between;
      }
      .right1 {
        line-height: 26px;
        font-size: 18px;
        color: #000;
        display: flex;
        align-items: center;
        .ylIcon {
          display: flex;
          align-items: center;
          padding-bottom: 1px;
        }
      }
      .right2 {
        float: right;
        margin-top: 2px;
      }
      .right5 {
        float: right;
      }
    }
  }
  .font16 {
    font-size: 16px;
  }
  // 叫号中
  .cont3 {
    background: #fff;
    padding: 16px;
    margin: 10px 0px 10px;
    &-title {
      font-size: 18px;
      padding-bottom: 14px;
    }
    &-left {
      font-size: 14px;
      line-height: 22px;
      padding: 0px 0px 7px;
      flex: 2;
      color: #4f4a4c;
      .top {
        background: #00c8d2;
        box-shadow: 0 2px 4px 0 rgba(0, 200, 210, 0.1);
        border-radius: 4px 0 13px 0;
        width: 55px;
        text-align: center;
        color: white;
        font-size: 18px;
        margin-bottom: 5px;
      }
      .left1 {
        line-height: 26px;
        font-size: 18px;
        color: #000;
      }
      .left2 {
        float: right;
        margin-top: 2px;
      }
      .left5 {
        float: right;
      }
    }
    &-right {
      flex: 1;
      display: flex;
      align-items: center;
      flex-direction: column;
      flex-flow: wrap;
      padding: 21px 0px;
      & > div {
        flex: 1;
        text-align: right;
      }
    }
  }
  .defaultBg {
    background-image: linear-gradient(270deg, #fff, #f8f8f8, #f4f5f6);
  }
  .pinkBg {
    background-image: linear-gradient(270deg, #fff, #fdebef);
  }
  .greyBg {
    background: #cacaca !important;
  }
  .mgBottom10 {
    margin-bottom: 10px;
  }
  .btn {
    height: 30px !important;
    width: 81px !important;
    padding: 0px !important;
    font-size: 16px !important;
  }
  .van-dialog__message {
    font-size: 16px;
  }
  .van-dialog__header {
    opacity: 0.9;
    font-size: 16px;
    color: #000000;
    text-align: center;
  }
}
</style>
<style lang="less">
.storeListDiv {
  .actionQueueReasonTitle {
    margin: 0;
    padding-bottom: 5px;
  }
  .el-select .el-input.is-focus .el-input__inner,
  .el-select .el-input__inner:focus {
    border-color: rgb(192, 196, 204) !important;
  }
}
.el-select {
  width: 100%;
}
.el-select-dropdown__item.selected {
  color: #008b5e !important;
}
.elSelectpopper {
  z-index: 5000 !important;
}
.el-select-dropdown {
  width: 285px;
}
.vanDialog .van-cell {
  margin-top: 5px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  textarea::-webkit-input-placeholder {
    color: rgb(192, 196, 204);
  }
}
// .el-scrollbar__wrap {
//   width: 300px;
//   box-sizing: border-box;
// }
.el-scrollbar {
  > .el-scrollbar__bar {
    opacity: 1 !important;
  }
}
</style>
